<!-- <div class="workflow-settings-container"> -->
<wm-common-overlay-modal
  class="contained-overlay"
  [isOpen]="true"
  [headerTitle]="'Workflow Settings'"
  maxWidth="100%"
  [height]="'100%'"
  (closed)="close()"
>
  <form [formGroup]="form" *ngIf="workflow">
    <div class="workflow-container">
      <!-- SETTINGS TITLE -->
      <wm-common-text
        [data]="{ text: 'Settings', variant: 'label', fontWeight: 600 }"
      ></wm-common-text>

      <!-- TOP SECTION -->
      <div class="top-section">
        <!-- LEFT -->
        <div class="left-section">
          <wm-common-textfield
            formControlName="name"
            [(ngModel)]="workflow.version.name"
            [ngModelOptions]="{ standalone: true }"
            [ngModelOptions]="{ standalone: true }"
            [data]="{ label: 'Name', required: true }"
          ></wm-common-textfield>
          <div class="error-text-workflow" *ngIf="getError('name')">
            {{ getError('name') }}
          </div>
          <wm-common-textfield
            formControlName="description"
            [(ngModel)]="workflow.version.description"
            [ngModelOptions]="{ standalone: true }"
            [ngModelOptions]="{ standalone: true }"
            [data]="{ label: 'Description' }"
          ></wm-common-textfield>

          <div
            class="floating-label-field"
            [class.has-value]="!!form.get('departmentId')?.value"
          >
            <label class="floating-label"
              >Department<span class="required-star">*</span></label
            >
            <wm-common-dropdown
              formControlName="departmentId"
              [data]="{
                placeholder: 'Department',
                required: true,
                options: departmentOptions
              }"
            ></wm-common-dropdown>
          </div>
          <div class="error-text-workflow" *ngIf="getError('departmentId')">
            {{ getError('departmentId') }}
          </div>
        </div>

        <!-- RIGHT -->
        <div class="right-section">
          <div class="description-template-field">
            <label class="description-template-label"
              >Application Description Template</label
            >
            <div class="description-editor-shell">
              <div
                #descriptionPreview
                class="description-editor-preview"
                [innerHTML]="applicationDescriptionPreviewHtml"
              ></div>
              <textarea
                #descInput
                class="description-editor-textarea"
                [value]="workflow.version.applicationDescriptionTemplate || ''"
                (input)="onDescriptionInput($event)"
                (click)="onCursorChange($event)"
                (keyup)="onCursorChange($event)"
                (select)="onCursorChange($event)"
                (scroll)="onDescriptionScroll($event)"
              ></textarea>
            </div>

            <div class="entity-search-shell">
              <input
                #entitySearchInput
                class="entity-search-input"
                type="text"
                [(ngModel)]="entitySearchText"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Search Data Entities"
                autocomplete="off"
                (focus)="onEntitySearchFocus()"
                (click)="openEntitySearchDropdown()"
                (input)="onEntitySearchInput()"
                (blur)="onEntitySearchBlur()"
              />
              <button
                type="button"
                class="entity-search-toggle"
                (mousedown)="$event.preventDefault()"
                (click)="toggleEntitySearchDropdown()"
              >
                <mat-icon
                  class="entity-search-icon"
                  [class.open]="showEntitySearchResults"
                >
                  keyboard_arrow_down
                </mat-icon>
              </button>

              <div
                class="entity-search-results"
                *ngIf="showEntitySearchResults"
              >
                <button
                  type="button"
                  class="entity-search-result"
                  *ngFor="let option of filteredEntityOptions"
                  (mousedown)="onEntitySelect(option)"
                >
                  {{ option.label }}
                </button>

                <div
                  class="entity-search-empty"
                  *ngIf="!filteredEntityOptions.length"
                >
                  No matching data entities
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- TAG + CATEGORY -->
      <div class="middle-section">
        <!-- TAGS -->
        <div class="card-tags-workflow-category">
          <wm-common-text
            [data]="{ text: 'Tags', fontWeight: 600 }"
          ></wm-common-text>

          <wm-common-dropdown
            (change)="onTagSelect($event)"
            [data]="{
              placeholder: 'Tags',
              options: tagOptions
            }"
          >
          </wm-common-dropdown>

          <div class="add-btn">
            <wm-common-button
              class="submit-button"
              [data]="{ text: 'ADD' }"
              (click)="addTag()"
            ></wm-common-button>
          </div>

          <div class="tag-list">
            <wm-common-chip
              *ngFor="let tag of selectedTags"
              [data]="{
                label: tag.name,
                removable: true,
                id: tag.id
              }"
              (onDelete)="removeTag(tag)"
            >
            </wm-common-chip>
          </div>
        </div>

        <!-- WORKFLOW CATEGORY -->
        <div class="card-tags-workflow-category workflow-category-card">
          <div class="card-header-blank">
            <wm-common-text
              [data]="{ text: 'Workflow Categories', fontWeight: 600 }"
            ></wm-common-text>
            <!-- <span class="toggle">Enable</span> -->

            <div class="toggle-block">
              <!-- <label class="toggle-item"> -->
              <wm-common-text
                class="toggle-label"
                [data]="{ text: 'Enable', fontWeight: 400, fontSize: '20px' }"
              ></wm-common-text>
              <input
                type="checkbox"
                class="native-toggle"
                [(ngModel)]="isCategoryEnabled"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onCategoriesToggle($event)"
              />

              <!-- </label> -->
            </div>
          </div>

          <wm-common-text
            *ngIf="!isCategoryEnabled"
            [data]="{
              text:
                'Categories are currently disabled. Enable categories using the toggle above to start organizing your workflow.',
              variant: 'caption'
            }"
          ></wm-common-text>
          <div *ngIf="isCategoryEnabled" class="category-container">
            <!-- ADD BUTTON -->
            <div class="add-category-btn">
              <wm-common-button
                [data]="{ text: 'ADD CATEGORY', disabled: showAddCategoryForm }"
                (click)="openCategoryForm()"
              >
              </wm-common-button>
            </div>

            <div *ngIf="showAddCategoryForm" class="category-form-inline">
              <div class="category-form">
                <h3>Add New Category</h3>

                <!-- Name -->
                <wm-common-textfield
                  [(ngModel)]="newCategory.name"
                  [ngModelOptions]="{ standalone: true }"
                  [data]="{ label: 'Name *' }"
                >
                </wm-common-textfield>

                <!-- Buttons -->
                <div class="form-actions">
                  <div class="save-btn-category">
                    <wm-common-button
                      [data]="{ text: 'SAVE CATEGORY' }"
                      (click)="addCategory()"
                    >
                    </wm-common-button>
                  </div>

                  <div class="cancel-btn-category">
                    <wm-common-button
                      [data]="{ text: 'CANCEL' }"
                      (click)="closeCategoryForm()"
                    >
                    </wm-common-button>
                  </div>
                </div>
              </div>
            </div>

            <!-- LIST -->
            <div
              class="category-list"
              cdkDropList
              (cdkDropListDropped)="onDrop($event)"
            >
              <div class="category-item" *ngFor="let cat of categories" cdkDrag>
                <div *ngIf="!cat.isEditing" class="category-row">
                  <div class="drag-icon">⋮⋮</div>

                  <div class="category-content">
                    <div class="title">
                      <b>{{ cat.name }}</b>
                      <span *ngIf="cat.isStatic"> - (System)</span>
                    </div>
                  </div>
                  <!-- RIGHT ACTIONS -->
                  <div class="category-actions" *ngIf="!cat.isStatic">
                    <!-- EDIT ICON -->
                    <wm-common-icon
                      class="action-icon edit-icon-category"
                      [data]="{ iconName: 'edit' }"
                      (click)="editCategory(cat)"
                    >
                    </wm-common-icon>

                    <!-- DELETE ICON -->
                    <wm-common-icon
                      class="action-icon delete-icon"
                      [data]="{ iconName: 'delete' }"
                      (click)="deleteCategory(cat)"
                    >
                    </wm-common-icon>
                  </div>
                </div>

                <!-- EDIT MODE -->
                <div *ngIf="cat.isEditing" class="edit-form">
                  <wm-common-textfield
                    [(ngModel)]="cat.name"
                    [ngModelOptions]="{ standalone: true }"
                    [data]="{ label: 'Name *' }"
                  >
                  </wm-common-textfield>

                  <span class="save-btn-category" style="margin-right: 10px;">
                    <wm-common-button
                      [data]="{ text: 'Save' }"
                      (click)="saveCategory(cat)"
                    >
                    </wm-common-button>
                  </span>

                  <span class="cancel-btn-category">
                    <wm-common-button
                      [data]="{ text: 'Cancel' }"
                      (click)="cancelEdit(cat)"
                    >
                    </wm-common-button>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- APPLICATION NUMBER SETTINGS -->
      <div class="full-card">
        <wm-common-text
          [data]="{ text: 'Application Number Settings', fontWeight: 600 }"
        ></wm-common-text>

        <!-- ROW -->
        <div class="form-row-app-number">
          <!-- Prefix -->
          <div class="prefix-field" *ngIf="!isPrefixEditMode">
            <wm-data-entity-formula
              [required]="true"
              [workflow]="workflow"
              [thenLabelGetter]="getThenLabel"
              (criteriaChanged)="updateCriteria($event)"
              [criteria]="workflow.numberPrefixCriteria"
              formulaTitle="Number Prefix"
              [onlyGlobalDataEntities]="true"
            >
            </wm-data-entity-formula>
          </div>
          <!-- Starting number -->
          <div class="field-with-info">
            <wm-common-textfield
              [ngModelOptions]="{ standalone: true }"
              formControlName="startingNumber"
              [data]="{ label: 'Starting number', type: 'number' }"
            >
            </wm-common-textfield>
            <!-- <span class="info-icon custom-tooltip" data-tooltip="Starting number of applications">i</span> -->
          </div>

          <!-- Fixed length -->
          <div>
            <div class="field-with-info">
              <wm-common-textfield
                [ngModelOptions]="{ standalone: true }"
                formControlName="totalLength"
                [data]="{ label: 'Fixed number length', type: 'number' }"
              >
              </wm-common-textfield>
              <span
                class="info-icon custom-tooltip"
                style="margin-top: 25px;"
                data-tooltip="Total number of digits of the numeric portion of the application number. The number will be padded with zeros to make up the full length."
                >i</span
              >
            </div>
            <div class="">
              <!-- Preview: {{ fixedNumberPreview }} -->
              <wm-common-text
                [data]="{ text: 'Preview: ' + fixedNumberPreview }"
              ></wm-common-text>
            </div>
          </div>
        </div>

        <div class="auto-reset-row">
          <!-- LEFT -->
          <div>
            <div class="toggle-item">
              <wm-common-checkbox
                (change)="onAutoResetToggle($event)"
                [data]="{
                  variant: 'toggle',
                  label: 'Auto Reset?',
                  checked: isAutoResetEnabled
                }"
              >
              </wm-common-checkbox>
              <span
                style="margin-bottom: 8px;"
                class="info-icon custom-tooltip"
                data-tooltip="The auto reset will not effect applications that have already had a number generated prior to setting this value."
                >i</span
              >
            </div>
            <div *ngIf="nextResetDate">
              <label class="bmd-label-static" for="resetMonth">
                Next Reset On
              </label>
              <div>{{ nextResetDate }}</div>
            </div>
          </div>

          <!-- RIGHT -->
          <div *ngIf="isAutoResetEnabled" class="auto-reset-fields">
            <div class="field-with-info">
              <wm-common-dropdown
                formControlName="resetMonth"
                [data]="{
                  placeholder: 'Month',
                  options: months,
                  id: 'resetMonth'
                }"
                (change)="onMonthChange($event)"
              >
              </wm-common-dropdown>
              <span
                class="info-icon custom-tooltip"
                data-tooltip="Month of year you want the number to reset."
                >i</span
              >
              <div class="error-text-workflow" *ngIf="getError('resetMonth')">
                {{ getError('resetMonth') }}
              </div>
            </div>
            <div class="field-with-info">
              <wm-common-dropdown
                formControlName="resetDay"
                [data]="{ placeholder: 'Day', options: days }"
                (change)="onDayChange($event)"
              >
              </wm-common-dropdown>
              <span
                class="info-icon custom-tooltip"
                data-tooltip="Month of year you want the number to reset."
                >i</span
              >
              <div class="error-text-workflow" *ngIf="getError('resetDay')">
                {{ getError('resetDay') }}
              </div>
            </div>
            <!-- <div *ngIf="nextResetDate">
              Next Reset On: {{ nextResetDate }}
            </div> -->
          </div>
        </div>
      </div>

      <div class="toggle-row custom-toggle">
        <wm-common-checkbox
          (change)="onPublicToggle($event)"
          [data]="{
            variant: 'toggle',
            label: 'Visible to public users?',
            checked: visibleToPublic
          }"
        >
        </wm-common-checkbox>
      </div>

      <!-- AUTO VOID -->
      <div class="auto-void-container" *ngIf="isEditMode">
        <div class="auto-void-header">
          <!-- LEFT -->
          <wm-common-text
            [data]="{
              text: 'Auto Void Application Settings',
              fontWeight: 500,
              fontSize: '20px'
            }"
          >
          </wm-common-text>

          <!-- RIGHT -->
          <div class="auto-toggle">
            <!-- <input type="checkbox" class="native-toggle" [(ngModel)]="isAutoVoidEnabled" />
            <span class="enable-text">Enable</span> -->
            <wm-common-checkbox
              (change)="onAutoVoidToggle($event)"
              [data]="{
                variant: 'toggle',
                label: 'Enable',
                checked: isAutoVoidEnabled
              }"
            >
            </wm-common-checkbox>
          </div>
        </div>
        <div
          *ngIf="isAutoVoidEnabled"
          formGroupName="autoVoidSettings"
          class="auto-void-fields"
        >
          <div>
            <wm-common-dropdown
              formControlName="goBeyondActivity"
              [data]="{
                placeholder: 'Activity to go beyond',
                options: activityOptions
              }"
            >
            </wm-common-dropdown>
            <div
              class="error-text-workflow"
              *ngIf="getAutoVoidError('goBeyondActivity')"
            >
              {{ getAutoVoidError('goBeyondActivity') }}
            </div>
          </div>

          <div class="days-until-void-field">
            <wm-common-textfield
              formControlName="daysUntilVoid"
              [data]="{
                label: 'Days until void',
                type: 'number'
              }"
            >
            </wm-common-textfield>
            <div
              class="error-text-workflow"
              *ngIf="getAutoVoidError('daysUntilVoid')"
            >
              {{ getAutoVoidError('daysUntilVoid') }}
            </div>
          </div>
        </div>
        <div *ngIf="autoVoidExample">
          <div class="col">
            <p>Example: {{ autoVoidExample }}</p>
          </div>
        </div>
      </div>

      <!-- FOOTER -->
      <div class="footer-container">
        <!-- TOP DROPDOWNS -->
        <div class="footer-fields">
          <div>
            <wm-common-dropdown
              formControlName="adminRole"
              [(ngModel)]="workflow.version.adminRoleId"
              [ngModelOptions]="{ standalone: true }"
              (change)="selectRole($event)"
              [data]="{
                placeholder: 'Administrative Role',
                options: roleOptions
              }"
            ></wm-common-dropdown>
            <div class="error-text-workflow" *ngIf="getError('adminRole')">
              {{ getError('adminRole') }}
            </div>
          </div>

          <div *ngIf="!adminRoleValid" class="text-danger">
            Selected Role is invalid or removed.
          </div>
          <wm-common-dropdown
            formControlName="workflowType"
            [(ngModel)]="workflow.workflowType"
            [ngModelOptions]="{ standalone: true }"
            (change)="workflowTypeChanged($event)"
            [data]="{
              placeholder: 'Workflow Type',
              options: typeOptions
            }"
          ></wm-common-dropdown>
          <div class="error-text-workflow" *ngIf="getError('workflowType')">
            {{ getError('workflowType') }}
          </div>
        </div>

        <div *ngIf="workflow.workflowType == 4" class="renewable-card">
          <!-- CARD -->
          <div class="renewal-container">
            <!-- Renewal Workflow -->
            <div class="field-block ">
              <label class="field-label">Renewal Workflow</label>

              <div class="field-with-info">
                <wm-common-dropdown
                  formControlName="renewalWorkflowId"
                  [data]="{
                    placeholder: 'Select Renewal Workflow',
                    options: renewalWorkflowOptions
                  }"
                >
                </wm-common-dropdown>

                <span
                  class="info-icon"
                  data-tooltip="After a renewable registration is created through this workflow, renewals of that registration can be processed by this workflow, or another renewable workflow can be selected."
                  >i</span
                >
              </div>
            </div>

            <!-- Expiration -->
            <div class="field-block">
              <label class="field-label">Expiration Date</label>

              <wm-common-dropdown
                formControlName="expirationType"
                [ngModelOptions]="{ standalone: true }"
                (change)="onExpirationOptionChange($event)"
                [data]="{
                  placeholder: 'Select expiration',
                  options: expirationOptions
                }"
              >
              </wm-common-dropdown>
            </div>

            <div
              class="field-block"
              *ngIf="form.get('expirationType')?.value == 'custom-months'"
            >
              <wm-common-textfield
                formControlName="termLength"
                [data]="{ label: 'Term length from issue date (months)' }"
              >
              </wm-common-textfield>
            </div>
            <div
              class="error-text-workflow"
              *ngIf="
                form.get('termLength')?.touched &&
                form.get('termLength')?.invalid
              "
            >
              Term length is required
            </div>

            <div
              class="field-block"
              *ngIf="form.get('expirationType')?.value == 'custom-formula'"
            >
              <wm-data-entity-formula
                [required]="true"
                [workflow]="workflow"
                [thenLabelGetter]="getThenLabel"
                (criteriaChanged)="updateExpirationCriteria($event)"
                [criteria]="customFormulaCriteria"
                formulaTitle="Custom Expiration Date Formula"
                [onlyGlobalDataEntities]="false"
              >
              </wm-data-entity-formula>
            </div>

            <!-- Requirements Section -->
            <div class="requirements-section">
              <div class="req-header">
                <h3>Requirements</h3>

                <wm-common-button
                  [data]="{
                    text: 'ADD REQUIREMENT',
                    disabled: !!newRequirement
                  }"
                  (click)="addRequirement()"
                >
                </wm-common-button>
              </div>

              <div *ngIf="newRequirement">
                <wm-requirement-editor
                  [requirement]="newRequirement"
                  [parentForm]="form"
                  [entities]="entities"
                  (cancelled)="newRequirementCancelled()"
                  (applied)="newRequirementApplied($event)"
                  [isOpen]="true"
                >
                </wm-requirement-editor>
              </div>

              <!-- LIST -->
              <div *ngIf="requirements.length === 0 && !newRequirement">
                There are not any requirements for this renewal
              </div>

              <div *ngFor="let req of requirements">
                <!-- EDIT MODE -->
                <div *ngIf="entities">
                  <wm-requirement-editor
                    [requirement]="req"
                    [parentForm]="form"
                    [entities]="entities"
                    (removed)="removeRequirement($event)"
                  >
                  </wm-requirement-editor>
                </div>
              </div>
            </div>
          </div>
        </div>

        <wm-advanced-permissions-editor
          [securable]="workflow"
          permissionTitle="Permissions for this workflow"
          *ngIf="workflow.id && workflow.id !== EMPTY_GUID"
          #advancedPermissions
        ></wm-advanced-permissions-editor>

        <!-- SAVE BUTTON -->
        <div class="footer-action">
          <button class="save-btn" (click)="saveWorkflow()">
            {{ isSaving ? 'Saving...' : 'Save' }}
          </button>
        </div>
      </div>
    </div>
  </form>

  <wm-common-confirmation-modal
    [data]="deleteConfirmModal"
    (onYesClick)="confirmDeleteNote()"
    (onNoClick)="closeDeleteNoteModal()"
    [isApplicantMobileview]="true"
  >
    <!-- 🔥 CUSTOM CONTENT -->
    <div class="custom-modal-content">
      <p>Some things to take note of.</p>
      <ul>
        <li>This tag will be removed from this workflow.</li>
      </ul>
    </div>
  </wm-common-confirmation-modal>

  <wm-common-confirmation-modal
    [data]="categoryDeleteModal"
    (onYesClick)="confirmDeleteCategory()"
    (onNoClick)="closeCategoryDeleteModal()"
    [isApplicantMobileview]="true"
  >
    <div class="custom-modal-content">
      <p>Some things to take note of.</p>
      <ul>
        <li>This category will be permanently deleted.</li>
      </ul>
    </div>
  </wm-common-confirmation-modal>

  <wm-modal-confirm
    #disableCategoriesModal
    [title]="'Disable Workflow Categories'"
    [showCommandText]="true"
    [commandText]="'Yes, Disable'"
    [cancelText]="'Cancel'"
    (accepted)="confirmDisableCategories()"
    (cancelled)="cancelDisableCategories()"
    [janusStyling]="true"
    [showButton]="false"
    [isJanusMobileview]="true"
  >
    Are you sure you want to disable workflow categories? All custom categories
    will be removed from this workflow. This action cannot be undone.
  </wm-modal-confirm>
</wm-common-overlay-modal>
<!-- </div> -->
